import axios from "axios";
import { Base_URL } from "../url";

export const fetchRegions = async () => {
  try {
    const response = await axios.get(`${Base_URL}/RegionMaster/GetAllRegions`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching regions!";
  }
};

export const downloadRegionsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/RegionMaster/DownloadRegionsExcel`,
      {}, // Assuming body is empty
      {
        responseType: "blob", // Important for file downloads
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading Excel!";
  }
};
